import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import DocumentRow from './DocumentRow';
import Grid from 'material-ui/Grid';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: '30px'
  },
  tableHeader: {
    fontSize: '1rem',
    fontWeight: 'Bold'
  },
  table: {
    minWidth: 800
  },
  Paper: {
    overflowX: 'auto'
  }
});

function DocumentsTable(props) {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <Grid container spacing={8} justify="center">
        <Grid item xs={12} lg={10}>
          <Paper className={classes.Paper}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeader}>
                    Participant Name
                  </TableCell>
                  <TableCell className={classes.tableHeader}>
                    Participant Email
                  </TableCell>
                  <TableCell className={classes.tableHeader}>
                    Document Name
                  </TableCell>
                  <TableCell className={classes.tableHeader}>Created</TableCell>
                  <TableCell className={classes.tableHeader} />
                </TableRow>
              </TableHead>
              <TableBody>
                {props.documents &&
                  props.documents.length === 0 && (
                    <TableRow>
                      <TableCell>No documents for in person signing.</TableCell>
                    </TableRow>
                  )}
                <DocumentRow
                  documents={props.documents}
                  updateDocuments={props.updateDocuments}
                  user={props.user}
                />
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

DocumentsTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DocumentsTable);



// WEBPACK FOOTER //
// ./src/components/DocumentsTable.js